export default __webpack_public_path__ + "static/PC_3_3_2-652e1d922c4e9896df4d370eca1355ab.png";